var EPaddleCountryValueEnglish = /*#__PURE__*/ function(EPaddleCountryValueEnglish) {
    EPaddleCountryValueEnglish["Afghanistan"] = "Afghanistan";
    EPaddleCountryValueEnglish["AlandIslands"] = "Aland Islands";
    EPaddleCountryValueEnglish["Albania"] = "Albania";
    EPaddleCountryValueEnglish["Algeria"] = "Algeria";
    EPaddleCountryValueEnglish["AmericanSamoa"] = "American Samoa";
    EPaddleCountryValueEnglish["Andorra"] = "Andorra";
    EPaddleCountryValueEnglish["Angola"] = "Angola";
    EPaddleCountryValueEnglish["Anguilla"] = "Anguilla";
    EPaddleCountryValueEnglish["AntiguaandBarbuda"] = "Antigua and Barbuda";
    EPaddleCountryValueEnglish["Argentina"] = "Argentina";
    EPaddleCountryValueEnglish["Armenia"] = "Armenia";
    EPaddleCountryValueEnglish["Aruba"] = "Aruba";
    EPaddleCountryValueEnglish["Australia"] = "Australia";
    EPaddleCountryValueEnglish["Austria"] = "Austria";
    EPaddleCountryValueEnglish["Azerbaijan"] = "Azerbaijan";
    EPaddleCountryValueEnglish["Bahamas"] = "Bahamas";
    EPaddleCountryValueEnglish["Bahrain"] = "Bahrain";
    EPaddleCountryValueEnglish["Bangladesh"] = "Bangladesh";
    EPaddleCountryValueEnglish["Barbados"] = "Barbados";
    EPaddleCountryValueEnglish["Belarus"] = "Belarus";
    EPaddleCountryValueEnglish["Belgium"] = "Belgium";
    EPaddleCountryValueEnglish["Belize"] = "Belize";
    EPaddleCountryValueEnglish["Benin"] = "Benin";
    EPaddleCountryValueEnglish["Bermuda"] = "Bermuda";
    EPaddleCountryValueEnglish["Bhutan"] = "Bhutan";
    EPaddleCountryValueEnglish["Bolivia"] = "Bolivia";
    EPaddleCountryValueEnglish["BonaireSintEustatiusandSaba"] = "Bonaire, Sint Eustatius and Saba";
    EPaddleCountryValueEnglish["BosniaandHerzegovina"] = "Bosnia and Herzegovina";
    EPaddleCountryValueEnglish["Botswana"] = "Botswana";
    EPaddleCountryValueEnglish["BouvetIsland"] = "Bouvet Island";
    EPaddleCountryValueEnglish["Brazil"] = "Brazil";
    EPaddleCountryValueEnglish["BritIndianOcean"] = "Brit. Indian Ocean";
    EPaddleCountryValueEnglish["BritishVirginIslands"] = "British Virgin Islands";
    EPaddleCountryValueEnglish["BruneiDarussalam"] = "Brunei Darussalam";
    EPaddleCountryValueEnglish["Bulgaria"] = "Bulgaria";
    EPaddleCountryValueEnglish["BurkinaFaso"] = "Burkina Faso";
    EPaddleCountryValueEnglish["Burundi"] = "Burundi";
    EPaddleCountryValueEnglish["Cambodia"] = "Cambodia";
    EPaddleCountryValueEnglish["Cameroon"] = "Cameroon";
    EPaddleCountryValueEnglish["Canada"] = "Canada";
    EPaddleCountryValueEnglish["CapeVerde"] = "Cape Verde";
    EPaddleCountryValueEnglish["CaymanIslands"] = "Cayman Islands";
    EPaddleCountryValueEnglish["CentralAfricanRepublic"] = "Central African Republic";
    EPaddleCountryValueEnglish["Chad"] = "Chad";
    EPaddleCountryValueEnglish["Chile"] = "Chile";
    EPaddleCountryValueEnglish["China"] = "China";
    EPaddleCountryValueEnglish["ChristmasIsland"] = "Christmas Island";
    EPaddleCountryValueEnglish["CocosIslands"] = "Cocos Islands";
    EPaddleCountryValueEnglish["Colombia"] = "Colombia";
    EPaddleCountryValueEnglish["Comoros"] = "Comoros";
    EPaddleCountryValueEnglish["Congo"] = "Congo";
    EPaddleCountryValueEnglish["CookIslands"] = "Cook Islands";
    EPaddleCountryValueEnglish["CostaRica"] = "Costa Rica";
    EPaddleCountryValueEnglish["CoteDIvoire"] = "Cote D'Ivoire";
    EPaddleCountryValueEnglish["Croatia"] = "Croatia";
    EPaddleCountryValueEnglish["Cuba"] = "Cuba";
    EPaddleCountryValueEnglish["Cura\xe7ao"] = "Cura\xe7ao";
    EPaddleCountryValueEnglish["Cyprus"] = "Cyprus";
    EPaddleCountryValueEnglish["CzechRepublic"] = "Czech Republic";
    EPaddleCountryValueEnglish["Denmark"] = "Denmark";
    EPaddleCountryValueEnglish["Djibouti"] = "Djibouti";
    EPaddleCountryValueEnglish["Dominica"] = "Dominica";
    EPaddleCountryValueEnglish["DominicanRepublic"] = "Dominican Republic";
    EPaddleCountryValueEnglish["Ecuador"] = "Ecuador";
    EPaddleCountryValueEnglish["Egypt"] = "Egypt";
    EPaddleCountryValueEnglish["ElSalvador"] = "El Salvador";
    EPaddleCountryValueEnglish["EquatorialGuinea"] = "Equatorial Guinea";
    EPaddleCountryValueEnglish["Eritrea"] = "Eritrea";
    EPaddleCountryValueEnglish["Estonia"] = "Estonia";
    EPaddleCountryValueEnglish["Ethiopia"] = "Ethiopia";
    EPaddleCountryValueEnglish["FalklandIslands"] = "Falkland Islands";
    EPaddleCountryValueEnglish["FaroeIslands"] = "Faroe Islands";
    EPaddleCountryValueEnglish["Fiji"] = "Fiji";
    EPaddleCountryValueEnglish["Finland"] = "Finland";
    EPaddleCountryValueEnglish["Frankreich"] = "France";
    EPaddleCountryValueEnglish["FrenchGuiana"] = "French Guiana";
    EPaddleCountryValueEnglish["FrenchPolynesia"] = "French Polynesia";
    EPaddleCountryValueEnglish["FrenchSouthernTerr"] = "French Southern Terr.";
    EPaddleCountryValueEnglish["Gabon"] = "Gabon";
    EPaddleCountryValueEnglish["Gambia"] = "Gambia";
    EPaddleCountryValueEnglish["Georgia"] = "Georgia";
    EPaddleCountryValueEnglish["Germany"] = "Germany";
    EPaddleCountryValueEnglish["Ghana"] = "Ghana";
    EPaddleCountryValueEnglish["Gibraltar"] = "Gibraltar";
    EPaddleCountryValueEnglish["Greece"] = "Greece";
    EPaddleCountryValueEnglish["Greenland"] = "Greenland";
    EPaddleCountryValueEnglish["Grenada"] = "Grenada";
    EPaddleCountryValueEnglish["Guadeloupe"] = "Guadeloupe";
    EPaddleCountryValueEnglish["Guam"] = "Guam";
    EPaddleCountryValueEnglish["Guatemala"] = "Guatemala";
    EPaddleCountryValueEnglish["Guernsey"] = "Guernsey";
    EPaddleCountryValueEnglish["Guinea"] = "Guinea";
    EPaddleCountryValueEnglish["GuineaBissau"] = "Guinea-Bissau";
    EPaddleCountryValueEnglish["Guyana"] = "Guyana";
    EPaddleCountryValueEnglish["Haiti"] = "Haiti";
    EPaddleCountryValueEnglish["HeardMcdonaldIslands"] = "Heard/ Mcdonald Islands";
    EPaddleCountryValueEnglish["HolySeeVaticanCity"] = "Holy See/ Vatican City";
    EPaddleCountryValueEnglish["Honduras"] = "Honduras";
    EPaddleCountryValueEnglish["HongKong"] = "Hong Kong";
    EPaddleCountryValueEnglish["Hungary"] = "Hungary";
    EPaddleCountryValueEnglish["Iceland"] = "Iceland";
    EPaddleCountryValueEnglish["India"] = "India";
    EPaddleCountryValueEnglish["Indonesia"] = "Indonesia";
    EPaddleCountryValueEnglish["Iran"] = "Iran";
    EPaddleCountryValueEnglish["Iraq"] = "Iraq";
    EPaddleCountryValueEnglish["Ireland"] = "Ireland";
    EPaddleCountryValueEnglish["IsleofMan"] = "Isle of Man";
    EPaddleCountryValueEnglish["Israel"] = "Israel";
    EPaddleCountryValueEnglish["Italy"] = "Italy";
    EPaddleCountryValueEnglish["Jamaica"] = "Jamaica";
    EPaddleCountryValueEnglish["Japan"] = "Japan";
    EPaddleCountryValueEnglish["Jersey"] = "Jersey";
    EPaddleCountryValueEnglish["Jordan"] = "Jordan";
    EPaddleCountryValueEnglish["Kazakhstan"] = "Kazakhstan";
    EPaddleCountryValueEnglish["Kenya"] = "Kenya";
    EPaddleCountryValueEnglish["Kiribati"] = "Kiribati";
    EPaddleCountryValueEnglish["Kuwait"] = "Kuwait";
    EPaddleCountryValueEnglish["Kyrgyzstan"] = "Kyrgyzstan";
    EPaddleCountryValueEnglish["LaoPeoplesDR"] = "Lao People's DR";
    EPaddleCountryValueEnglish["Latvia"] = "Latvia";
    EPaddleCountryValueEnglish["Lebanon"] = "Lebanon";
    EPaddleCountryValueEnglish["Lesotho"] = "Lesotho";
    EPaddleCountryValueEnglish["Liberia"] = "Liberia";
    EPaddleCountryValueEnglish["LibyanArabJamahiriya"] = "Libyan Arab Jamahiriya";
    EPaddleCountryValueEnglish["Liechtenstein"] = "Liechtenstein";
    EPaddleCountryValueEnglish["Lithuania"] = "Lithuania";
    EPaddleCountryValueEnglish["Luxembourg"] = "Luxembourg";
    EPaddleCountryValueEnglish["Macao"] = "Macao";
    EPaddleCountryValueEnglish["Macedonia"] = "Macedonia";
    EPaddleCountryValueEnglish["Madagascar"] = "Madagascar";
    EPaddleCountryValueEnglish["Malawi"] = "Malawi";
    EPaddleCountryValueEnglish["Malaysia"] = "Malaysia";
    EPaddleCountryValueEnglish["Maldives"] = "Maldives";
    EPaddleCountryValueEnglish["Mali"] = "Mali";
    EPaddleCountryValueEnglish["Malta"] = "Malta";
    EPaddleCountryValueEnglish["MarshallIslands"] = "Marshall Islands";
    EPaddleCountryValueEnglish["Martinique"] = "Martinique";
    EPaddleCountryValueEnglish["Mauritania"] = "Mauritania";
    EPaddleCountryValueEnglish["Mauritius"] = "Mauritius";
    EPaddleCountryValueEnglish["Mayotte"] = "Mayotte";
    EPaddleCountryValueEnglish["Mexico"] = "Mexico";
    EPaddleCountryValueEnglish["Micronesia"] = "Micronesia";
    EPaddleCountryValueEnglish["Moldova"] = "Moldova";
    EPaddleCountryValueEnglish["Monaco"] = "Monaco";
    EPaddleCountryValueEnglish["Mongolia"] = "Mongolia";
    EPaddleCountryValueEnglish["Montenegro"] = "Montenegro";
    EPaddleCountryValueEnglish["Montserrat"] = "Montserrat";
    EPaddleCountryValueEnglish["Morocco"] = "Morocco";
    EPaddleCountryValueEnglish["Mozambique"] = "Mozambique";
    EPaddleCountryValueEnglish["Myanmar"] = "Myanmar";
    EPaddleCountryValueEnglish["Namibia"] = "Namibia";
    EPaddleCountryValueEnglish["Nauru"] = "Nauru";
    EPaddleCountryValueEnglish["Nepal"] = "Nepal";
    EPaddleCountryValueEnglish["Netherlands"] = "Netherlands";
    EPaddleCountryValueEnglish["NetherlandsAntilles"] = "Netherlands Antilles";
    EPaddleCountryValueEnglish["NewCaledonia"] = "New Caledonia";
    EPaddleCountryValueEnglish["NewZealand"] = "New Zealand";
    EPaddleCountryValueEnglish["Nicaragua"] = "Nicaragua";
    EPaddleCountryValueEnglish["Niger"] = "Niger";
    EPaddleCountryValueEnglish["Nigeria"] = "Nigeria";
    EPaddleCountryValueEnglish["Niue"] = "Niue";
    EPaddleCountryValueEnglish["NorfolkIsland"] = "Norfolk Island";
    EPaddleCountryValueEnglish["NorthKorea"] = "North Korea";
    EPaddleCountryValueEnglish["NorthernMarianaIslands"] = "Northern Mariana Islands";
    EPaddleCountryValueEnglish["Norway"] = "Norway";
    EPaddleCountryValueEnglish["Oman"] = "Oman";
    EPaddleCountryValueEnglish["Pakistan"] = "Pakistan";
    EPaddleCountryValueEnglish["Palau"] = "Palau";
    EPaddleCountryValueEnglish["PalestinianTerritory"] = "Palestinian Territory";
    EPaddleCountryValueEnglish["Panama"] = "Panama";
    EPaddleCountryValueEnglish["PapuaNewGuinea"] = "Papua New Guinea";
    EPaddleCountryValueEnglish["Paraguay"] = "Paraguay";
    EPaddleCountryValueEnglish["Peru"] = "Peru";
    EPaddleCountryValueEnglish["Philippines"] = "Philippines";
    EPaddleCountryValueEnglish["Pitcairn"] = "Pitcairn";
    EPaddleCountryValueEnglish["Poland"] = "Poland";
    EPaddleCountryValueEnglish["Portugal"] = "Portugal";
    EPaddleCountryValueEnglish["PuertoRico"] = "Puerto Rico";
    EPaddleCountryValueEnglish["Qatar"] = "Qatar";
    EPaddleCountryValueEnglish["RepublicofSerbia"] = "Republic of Serbia";
    EPaddleCountryValueEnglish["Reunion"] = "Reunion";
    EPaddleCountryValueEnglish["Romania"] = "Romania";
    EPaddleCountryValueEnglish["RussianFederation"] = "Russian Federation";
    EPaddleCountryValueEnglish["Rwanda"] = "Rwanda";
    EPaddleCountryValueEnglish["SGeorgiaSandwichIslands"] = "S. Georgia/ Sandwich Islands";
    EPaddleCountryValueEnglish["SaintHelena"] = "Saint Helena";
    EPaddleCountryValueEnglish["SaintKittsandNevis"] = "Saint Kitts and Nevis";
    EPaddleCountryValueEnglish["SaintLucia"] = "Saint Lucia";
    EPaddleCountryValueEnglish["SaintMartin"] = "Saint Martin";
    EPaddleCountryValueEnglish["SaintPierreandMiquelon"] = "Saint Pierre and Miquelon";
    EPaddleCountryValueEnglish["SaintVincentGrenadines"] = "Saint Vincent/ Grenadines";
    EPaddleCountryValueEnglish["Samoa"] = "Samoa";
    EPaddleCountryValueEnglish["SanMarino"] = "San Marino";
    EPaddleCountryValueEnglish["SaoTomeandPrincipe"] = "Sao Tome and Principe";
    EPaddleCountryValueEnglish["SaudiArabia"] = "Saudi Arabia";
    EPaddleCountryValueEnglish["Senegal"] = "Senegal";
    EPaddleCountryValueEnglish["Seychelles"] = "Seychelles";
    EPaddleCountryValueEnglish["SierraLeone"] = "Sierra Leone";
    EPaddleCountryValueEnglish["Singapore"] = "Singapore";
    EPaddleCountryValueEnglish["Slovakia"] = "Slovakia";
    EPaddleCountryValueEnglish["Slovenia"] = "Slovenia";
    EPaddleCountryValueEnglish["SolomonIslands"] = "Solomon Islands";
    EPaddleCountryValueEnglish["Somalia"] = "Somalia";
    EPaddleCountryValueEnglish["SouthAfrica"] = "South Africa";
    EPaddleCountryValueEnglish["SouthKorea"] = "South Korea";
    EPaddleCountryValueEnglish["Spain"] = "Spain";
    EPaddleCountryValueEnglish["SriLanka"] = "Sri Lanka";
    EPaddleCountryValueEnglish["Sudan"] = "Sudan";
    EPaddleCountryValueEnglish["Suriname"] = "Suriname";
    EPaddleCountryValueEnglish["SvalbardandJanMayen"] = "Svalbard and Jan Mayen";
    EPaddleCountryValueEnglish["Swaziland"] = "Swaziland";
    EPaddleCountryValueEnglish["Sweden"] = "Sweden";
    EPaddleCountryValueEnglish["Switzerland"] = "Switzerland";
    EPaddleCountryValueEnglish["SyrianArabRepublic"] = "Syrian Arab Republic";
    EPaddleCountryValueEnglish["Taiwan"] = "Taiwan";
    EPaddleCountryValueEnglish["Tajikistan"] = "Tajikistan";
    EPaddleCountryValueEnglish["Tanzania"] = "Tanzania";
    EPaddleCountryValueEnglish["Thailand"] = "Thailand";
    EPaddleCountryValueEnglish["TimorLeste"] = "Timor-Leste";
    EPaddleCountryValueEnglish["Togo"] = "Togo";
    EPaddleCountryValueEnglish["Tokelau"] = "Tokelau";
    EPaddleCountryValueEnglish["Tonga"] = "Tonga";
    EPaddleCountryValueEnglish["TrinidadandTobago"] = "Trinidad and Tobago";
    EPaddleCountryValueEnglish["Tunisia"] = "Tunisia";
    EPaddleCountryValueEnglish["Turkey"] = "Turkey";
    EPaddleCountryValueEnglish["Turkmenistan"] = "Turkmenistan";
    EPaddleCountryValueEnglish["TurksandCaicosIslands"] = "Turks and Caicos Islands";
    EPaddleCountryValueEnglish["Tuvalu"] = "Tuvalu";
    EPaddleCountryValueEnglish["USVirginIslands"] = "U.S. Virgin Islands";
    EPaddleCountryValueEnglish["Uganda"] = "Uganda";
    EPaddleCountryValueEnglish["Ukraine"] = "Ukraine";
    EPaddleCountryValueEnglish["UnitedArabEmirates"] = "United Arab Emirates";
    EPaddleCountryValueEnglish["UnitedKingdom"] = "United Kingdom";
    EPaddleCountryValueEnglish["UnitedStates"] = "United States";
    EPaddleCountryValueEnglish["UnitedStatesMOI"] = "United States (M.O.I.)";
    EPaddleCountryValueEnglish["Uruguay"] = "Uruguay";
    EPaddleCountryValueEnglish["Uzbekistan"] = "Uzbekistan";
    EPaddleCountryValueEnglish["Vanuatu"] = "Vanuatu";
    EPaddleCountryValueEnglish["Venezuela"] = "Venezuela";
    EPaddleCountryValueEnglish["VietNam"] = "Viet Nam";
    EPaddleCountryValueEnglish["WallisandFutuna"] = "Wallis and Futuna";
    EPaddleCountryValueEnglish["WesternSahara"] = "Western Sahara";
    EPaddleCountryValueEnglish["Yemen"] = "Yemen";
    EPaddleCountryValueEnglish["Zambia"] = "Zambia";
    EPaddleCountryValueEnglish["Zimbabwe"] = "Zimbabwe";
    return EPaddleCountryValueEnglish;
}(EPaddleCountryValueEnglish || {});
export { EPaddleCountryValueEnglish };
